var map = {
	"./GG_MARKET_AERO.jpg": "919a",
	"./GG_MARKET_AGRIC.jpg": "581d",
	"./GG_MARKET_CONSTR.jpg": "2c6e",
	"./GG_MARKET_DEFENSE.jpg": "a914",
	"./GG_MARKET_ENVIRONMENT.jpg": "b844",
	"./GG_MARKET_INDUST.jpg": "a846",
	"./GG_MARKET_MINES.jpg": "ed77",
	"./GG_MARKET_OIL_GAS.jpg": "17a4",
	"./GG_MARKET_RENTALS.jpg": "315b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ffda";